<template>
  <el-autocomplete
    class="select-input-auto-main"
    v-model="data.title"
    :debounce="10"
    :hide-loading="true"
    label="title"
    value-key="name"
    :fetch-suggestions="remoteMethod"
    placeholder="请输入"
    @select="select"
    @input="select(value)"
    :select-when-unmatched="true"
    clearable
    >

    <template slot-scope="{ item }">
      <p v-html="item.highlight"></p>
    </template>

  </el-autocomplete>
</template>
<script>
	import api from '@/api'
	import { mapState, mapMutations } from 'vuex'

	export default {
		props: {
			data: {
        type: Object,
        default: {}
      }
		},
		data () {
			return {
				run: null,
				options: [],
				value: {
					name: ''
				},
				list: [],
				loading: false,
			}
		},
		computed: {
			...mapState('editor', [ 'currentInfo' ])
		},
		watch: {},
		methods: {
			...mapMutations('editor', [ 'setCurrentInfo', 'setPostId']),
			async remoteMethod (query, cb) {
				let params = {
          keyword: query
        };
        try {
          let res = await api.cvsEditor.positionAutoCompletions(params);
          if (res.code === 1000) {
            cb && cb((res.data || []));
          }
        } catch (e) {
          console.log('positionAutoCompletions error:', e)
        }
			},
			select (data) {
        if(data.profession_id){
          this.setPostId(data.profession_id)
        }else{
          this.setPostId('')
        }
			}
		}
	}
</script>
<style lang="scss" scoped>

  .select-input-auto-main {
    width: 100%;
  }

  /deep/ .es-highlighter {
    color: #FF6644;
  }

</style>
